import client from "../client";
import type {
  CredentialKind,
  HotelCredentialsPayload,
  UpsertCredentialBody,
} from "../../pages/tracking/health/types";

/**
 * Customer credentials — `GET/PUT/DELETE /admin/credentials/...` (admin JWT
 * via the shared client).
 *
 * Its own helper rather than a section of `tracking-health.ts` because it is
 * its own mount: credentials belong to the customer, and Tracking Health is
 * only the first surface to render them.
 *
 * Keyed by platform `userId`, NOT by Google Ads customer id — so unlike the
 * Tracking Health calls there is no digit-normalisation here, and an
 * unclaimed account (no matched owner) has no credentials to ask for.
 */
export const credentials = {
  forUser: (userId: string): Promise<HotelCredentialsPayload> =>
    client
      .get(`/admin/credentials/${encodeURIComponent(userId)}`)
      .then((r) => r.data),

  /** Omit `password` to leave the stored one untouched. */
  upsert: (
    userId: string,
    kind: CredentialKind,
    body: UpsertCredentialBody,
  ): Promise<HotelCredentialsPayload> =>
    client
      .put(`/admin/credentials/${encodeURIComponent(userId)}/${kind}`, body)
      .then((r) => r.data),

  /** Drops the hotel's exception; the platform default resolves underneath. */
  remove: (
    userId: string,
    kind: CredentialKind,
  ): Promise<HotelCredentialsPayload> =>
    client
      .delete(`/admin/credentials/${encodeURIComponent(userId)}/${kind}`)
      .then((r) => r.data),
};
